import * as React from "react";
class ChartLegend extends React.Component {
  BEM() {
    const classArray = ["chart-legend"];
    if (this.props.stacked) {
      classArray.push("chart-legend--stacked");
    }
    if (this.props.size) {
      classArray.push("chart-legend--" + this.props.size);
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  getLegendItem(item) {
    return /* @__PURE__ */ React.createElement("li", { className: "chart-legend__item", key: item.key }, /* @__PURE__ */ React.createElement("span", { className: "chart-legend__color", style: { background: item.color } }), /* @__PURE__ */ React.createElement("span", { className: "chart-legend__text" }, this.getLegendText(item)));
  }
  getLegendText(item) {
    if (this.props.format) {
      return this.props.format(item.key, item.text, item.val, item.valFormatted);
    }
    return item.text;
  }
  render() {
    return /* @__PURE__ */ React.createElement("ul", { className: this.BEM() }, this.props.items.map((item) => this.getLegendItem(item)));
  }
}
export {
  ChartLegend
};
